import styled from 'styled-components'
export const HiddenInput = styled.input`
  display: none; 
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const StyledLabel = styled.label`
  padding: 0;
  font: 16px/20px 'DMSans-Medium';
  cursor: pointer;
  border: none;
  background-color: #f8f8f8;
  display: inline-block;
  margin:0px;
  text-decoration: underline;
  &:hover {
    background-color: #eee;
  }

  border-color: ${props => props.state === 'error' ? 'red' : '#ccc'};
  @media (max-width: 768px) {
    text-align: center;
  }
`;